import { DefinitionDataSection } from '../../../types';
import { BooleanColumnConfigEditor } from './BooleanColumnConfigEditor';
import { DateColumnConfigEditor } from './DateColumnConfigEditor';
import { DateTimeColumnConfigEditor } from './DateTimeColumnConfigEditor';
import { StringColumnConfigEditor } from './StringColumnConfigEditor';
import { TimeColumnConfigEditor } from './TimeColumnConfigEditor';

type ColumnConfig = DefinitionDataSection['columns'][0]['config'];

interface ColumnTypeConfigEditorProps {
  column: DefinitionDataSection['columns'][0];
  onTypeChange: (config: ColumnConfig) => void;
}

export function ColumnTypeConfigEditor({ column, onTypeChange }: ColumnTypeConfigEditorProps) {
  const columnConfig = column.config;

  if (columnConfig.type === 'string') {
    return <StringColumnConfigEditor config={columnConfig} onTypeChange={onTypeChange} />;
  }

  if (columnConfig.type === 'boolean') {
    return <BooleanColumnConfigEditor config={columnConfig} onTypeChange={onTypeChange} />;
  }

  if (columnConfig.type === 'date') {
    return <DateColumnConfigEditor config={columnConfig} onTypeChange={onTypeChange} />;
  }

  if (columnConfig.type === 'datetime') {
    return <DateTimeColumnConfigEditor config={columnConfig} onTypeChange={onTypeChange} />;
  }

  if (columnConfig.type === 'time') {
    return <TimeColumnConfigEditor config={columnConfig} onTypeChange={onTypeChange} />;
  }

  if (columnConfig.type === 'url') {
    return null;
  }

  if (columnConfig.type === 'number') {
    return null;
  }

  return null;
}
